import { render } from "./GlobalFileView.vue?vue&type=template&id=57ccbaf0"
import script from "./GlobalFileView.vue?vue&type=script&lang=js"
export * from "./GlobalFileView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__